import {useEffect, useState} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import {useListView} from '../../../../utils/contextProvider/ListViewProvider'
import {useAuth} from '../../../auth'
import {useSenderIdProvider} from '../../context/SenderIdProvider'
import {ISenderId} from '../../core/_model'
import {Form} from 'react-bootstrap'

const BulkUpdateNonBranded = () => {
  const {currentUser} = useAuth()
  const {filteredSender, options, updateBulkNonBranded} = useSenderIdProvider() || {}
  const {selected} = useListView()

  const [brandedSender, setBrandedSender] = useState<ISenderId[]>([])
  const [selectRoute, setSelectRoute] = useState<string | undefined>(undefined)

  const onUpdate = () => {
    const sender = brandedSender.map((sender) => sender.sender)
    const senderIds = brandedSender.map((sender) => sender.id)

    if (selectRoute) {
      const routeId = parseInt(selectRoute)
      updateBulkNonBranded(sender, senderIds, routeId)
    }
  }

  useEffect(() => {
    const filteredResults: ISenderId[] = filteredSender.filter((sender: ISenderId) =>
      selected.includes(sender.id)
    )
    const brandedSender = filteredResults.filter((sender) => !sender.branded)
    setBrandedSender(brandedSender)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  return (
    <div className='modal fade' tabIndex={-11} id='kt_modal_11'>
      <div className='modal-dialog modal-dialog-centered modal-lg'>
        <div className='modal-content py-2'>
          <div className='modal-header border-0'>
            <h4 className='modal-title fs-1'>Bulk Update (Non Branded)</h4>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body px-10 pt-0'>
            {/* {brandedSender.length > 0 &&
              brandedSender.map((sender) => {
                return (
                  <span className='badge badge-light-primary d-inline-block m-2 fs-5'>
                    {sender.sender}
                  </span>
                )
              })} */}

            <div className='mt-10'>
              <label className='col-lg-4 col-form-label fs-6'>
                <span className='required fs-4'>Route</span>
              </label>
              <Form.Select
                value={selectRoute}
                onChange={(e) => setSelectRoute(e.target.value)}
                placeholder='Select a route'
                className='custom-input'
                required
              >
                <option value={undefined}>Select a route</option>
                {options &&
                  options.map((option: any) => {
                    return (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    )
                  })}
              </Form.Select>

              <div className='text-center'>
                <button
                  type='button'
                  className='btn btn-primary mt-6'
                  onClick={onUpdate}
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  Update Sender Ids
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BulkUpdateNonBranded
